/* eslint-disable max-len */
import { SvgIcon, SvgIconProps } from '@mui/material';

export default function NotStartedIcon(props: SvgIconProps) {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="16" height="27" viewBox="0 0 16 27" fill="none" {...props}>
      <path d="M0 0V8H0.0133336L0 8.01333L5.33333 13.3333L0 18.6667L0.0133336 18.68H0V26.6667H16V18.68H15.9867L16 18.6667L10.6667 13.3333L16 8.01333L15.9867 8H16V0H0ZM13.3333 19.3333V24H2.66667V19.3333L8 14L13.3333 19.3333ZM8 12.6667L2.66667 7.33333V2.66667H13.3333V7.33333L8 12.6667Z" />
    </SvgIcon>
  );
}


